import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { localize } from '@lichtblick/localization';
import { Logo } from '@lichtblick/photon/atoms/logo/logo';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import styles from './BaseFooter.module.css';
export const BaseFooter = ({ hasLogo, links, renderAs: Tag = 'footer' })=>{
    const highlightedLinks = links.filter(({ icon })=>icon);
    const regularLinks = links.filter(({ icon })=>!icon);
    return /*#__PURE__*/ _jsxs(Tag, {
        className: styles.footer,
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "Footer Navigation",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles['links-group'],
                    children: [
                        highlightedLinks.length > 0 ? /*#__PURE__*/ _jsx("ul", {
                            className: styles['links-row'],
                            children: highlightedLinks.map(({ href, icon, label, onClick })=>/*#__PURE__*/ _jsx("li", {
                                    className: styles['link-item-highlighted'],
                                    children: /*#__PURE__*/ _jsx(TextCTA, {
                                        as: "a",
                                        href: href,
                                        icon: icon,
                                        onClick: onClick,
                                        children: label
                                    })
                                }, href))
                        }) : undefined,
                        regularLinks.length > 0 ? /*#__PURE__*/ _jsx("ul", {
                            className: styles['links-row'],
                            children: regularLinks.map(({ href, icon, label, onClick })=>/*#__PURE__*/ _jsx("li", {
                                    className: styles['link-item'],
                                    children: /*#__PURE__*/ _jsx(TextCTA, {
                                        as: "a",
                                        href: href,
                                        icon: icon,
                                        onClick: onClick,
                                        children: label
                                    })
                                }, href))
                        }) : undefined
                    ]
                })
            }),
            hasLogo ? /*#__PURE__*/ _jsx("a", {
                className: styles.logo,
                href: "https://www.lichtblick.de",
                children: /*#__PURE__*/ _jsx(Logo, {})
            }) : undefined,
            /*#__PURE__*/ _jsx(Text, {
                className: styles.copyright,
                size: "xs",
                children: localize('© {{year}} LichtBlick', {
                    year: new Date().getFullYear()
                })
            })
        ]
    });
};

//# sourceMappingURL=BaseFooter.js.map